module.exports = __webpack_public_path__ + "img/icon-tab-index-active.d4cbc820.png";